import { Injectable } from '@angular/core';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { TopicConversionService } from '../../conversion/topic/topic-conversion.service';
import { Topic } from 'src/app/libs/proto/forum_pb';
import * as grpcWeb from 'grpc-web';
import { Observable } from 'rxjs';
import { Empty } from 'src/app/libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class GrpcTopicLibService {
  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: TopicConversionService

  ){}

  getTopic(option?: GrpcLibServiceOption): Promise<Topic[]>{
    return new Observable<Topic[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getTopicOffline(opt);
      } else {
        this._getTopicOnline(opt);
      }
    }).toPromise();
  }

  private _getTopicOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      this.storLib.get('topic'), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getTopicOnline(option: GrpcLibServiceOption){
    let t = this.userLib.Data.token?.getToken();
    this.grpcLib.MobileClient.getTopics(new Empty(), {
        token: t,
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getTopicOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getTopicOnlineStatus(s, option);
      })
      .on('data', (r: Topic) => {
        this._getTopicOnlineData(r, option);
      })
      .on('end', () => {
        this._getTopicOnlineEnd(option);
      });
  }
  private _getTopicOnlineData(ret: Topic, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getTopicOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getTopicOnline(option);
    }, option);
  }

  private _getTopicOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }
  private _getTopicOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.topic = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'topic', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }
    }
  }



}
